import React from "react";

const TableShowLimit = ({
  paginationCurrentLimit,
  setPaginationCurrentLimit,
  disabled = false,
}) => {
  return (
    <>
     <div className="flex items-center">
      <label htmlFor="pagination" className="text-xs mr-2">
        Rows per page:
      </label>
      <div className="text-xs">
        <select
          name="pagination"
          id="pagination"
          defaultValue={paginationCurrentLimit}
          onChange={(e) => {
            setPaginationCurrentLimit(Number(e.target.value));
          }}
          className="px-1"
          disabled={disabled} // Disable when no data
        >
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
          <option value="25">25</option>
        </select>
      </div>
    </div>
    </>
  );
};

export default TableShowLimit;
